import { render } from "./fleet.cattle.io.cluster.vue?vue&type=template&id=1920f0c5"
import script from "./fleet.cattle.io.cluster.vue?vue&type=script&lang=js"
export * from "./fleet.cattle.io.cluster.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__